import { useCallback } from 'react'; // skipcq: JS-0128
// formik
import { Field } from 'formik';
import { CheckboxWithLabel } from 'formik-mui';
// mui
import Grid from '@mui/material/Grid';

function TempClosedForm({ handleChange, handleBlur, setFieldTouched }) {
  const onChange = useCallback(
    (e) => {
      // Mark as touched and propagate change to trigger validation/state updates
      setFieldTouched('isTempClosed');
      handleBlur(e);
      handleChange(e);
    },
    [handleBlur, handleChange, setFieldTouched],
  );

  return (
    <Grid container spacing={0} item xs={12}>
      <Grid
        item
        xs={12}
        md={6}
        style={{ paddingLeft: '16px', paddingTop: '16px' }}
      >
        <Field
          component={CheckboxWithLabel}
          type="checkbox"
          Label={{ label: 'Temporarily Closed' }}
          name="isTempClosed"
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
}

export default TempClosedForm;
